import { render, staticRenderFns } from "./ColorPickerWithPresets.vue?vue&type=template&id=61e077e9&scoped=true&lang=pug"
import script from "./ColorPickerWithPresets.vue?vue&type=script&lang=js"
export * from "./ColorPickerWithPresets.vue?vue&type=script&lang=js"
import style0 from "./ColorPickerWithPresets.vue?vue&type=style&index=0&id=61e077e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e077e9",
  null
  
)

export default component.exports